import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getNetworkInquiriesSummary, getQuotationSellerListById, getSalesInquiryData } from "../../store/Sales/actions";
import { formatModifyDate, getAuthType, getInternalRoute } from "../../components/Common/CommonLogic";
import { QueriesColVal } from "../Sales/partials/SalesCol";
import { RATE_AVAILABLE, RATE_UPDATED } from "../Dashboard/Partials/initialData";
import { DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, UncontrolledDropdown } from "reactstrap";
import { upload_icon } from "../../assets/images";
import { MyInquiriesBreadcrumb } from "../../common/data/parties";
import StatsSummary from "../../components/GlobalComponent/StatsSummaryComponent";
import MyInquiriesTable from "./component/MyInquiriesTable";
import FilterSalesInquiryComp from "../Sales/partials/FilterSalesInquiryComp";
import { CommonValue } from "../Parties/PartiesCol";
import Page from "../../components/GlobalComponent/PageComponent";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import ViewDetails from "./modal/ViewDetails";

const MyInquiries = () => {
    document.title = "My Inquiry || Navigating Freight Costs with Precision||Ultimate Rate Management platform"

    const { inquiry_data_loader, networkInquiries } = useSelector((state) => state?.sales);
    const [isRight, setIsRight] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();

    const [show, setShow] = useState(false);
    const [showSellerList, setShowSellerList] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [modalStyle, setModalStyle] = useState({});
    const tableRef = useRef(null);
    const [rowData, setRowData] = useState(null);
    const boxRef = useRef(null);
    const dispatch = useDispatch();
    const [isViewDetailsOpen, setIsViewDetailsOpen] = useState(false);
    const [inquiriesId, setInquiriesId] = useState();
    const [inquiriesType, setInquiriesType] = useState();

    const inputArr = {
        org_port: '',
        dest_port: '',
        status: '',
        valid_from: '',
        valid_to: '',
        customer: '',
        sales_employee: '',
        isExcelGenerated: false
    }
    const [filterDetails, setfilterDetails] = useState(inputArr);

    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    };

    const constructUrl = (page, filters) => {
        let url = `?page=${page}&size=${filterDetails?.isExcelGenerated ? inquiry_data?.totalElements : 10}&`;
        url += `${filters?.customer?.id ? `customers=${filters?.customer.id}&` : ''}`;
        url += `${filters?.org_port?.id ? `origins=${filters?.org_port.id}&` : ''}`;
        url += `${filters?.dest_port?.id ? `destinations=${filters?.dest_port.id}&` : ''}`;
        url += `${filters?.sales_employee?.id ? `salesEmployees=${filters?.sales_employee.id}&` : ''}`;
        url += `${filters?.valid_from ? `validFrom=${filters?.valid_from}&` : ''}`;
        url += `${filters?.valid_to ? `validTo=${filters?.valid_to}&` : ''}`;
        url += `${filters?.status?.id ? `status=${filters?.status?.id}&` : ''}`;
        url += `${filters?.container_type?.id ? `containerType=${filters?.container_type?.id}&` : ''}`;
        url += `${filterDetails?.isExcelGenerated ? `isExcelGenerated=${true}&` : ''}`;
        url += 'requestForRates=false&';
        return url.substring(0, url.length - 1); // Remove trailing '&'
    };

    const applyFilterHandler = () => {
        setIsRight(false);
        filterDetails.isExcelGenerated = false;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getNetworkInquiriesSummary(url));
    };

    const clearValueHandler = () => {
        setIsRight(false);
        setfilterDetails(inputArr);
        let url = constructUrl(currentPage, {});
        dispatch(getNetworkInquiriesSummary(url));
    };

    useEffect(() => {
        //let url = constructUrl(currentPage, filterDetails);
        if (currentPage !== '' && currentPage !== undefined) {
            let url = `?isActiveInquiry=false&page=${currentPage}&size=25`;
            dispatch(getNetworkInquiriesSummary(url));
        }
        console.log("hit this");
    }, [dispatch, currentPage]);

    const downLoadExcelReport = () => {
        filterDetails.isExcelGenerated = true;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getSalesInquiryData(url));
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (boxRef.current && !boxRef.current.contains(event.target)) {
                setShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [boxRef]);

    const handleClose = () => {
        setShow(false);
    }

    const handleOnSellerIdClick = (sellerId, rowRect) => {
        dispatch(getQuotationSellerListById(sellerId));
        setRowData(rowRect)
    }

    const viewBids = (data) => {
        console.log(data);
        navigate('/view/bids', {
            state: {
                data: data
            },
        });
    };

    const toggleViewDetails = () => {
        setIsViewDetailsOpen(!isViewDetailsOpen);
    }

    const viewDetails = (objData) => {
        setInquiriesType(objData?.rateType)
        setInquiriesId(objData?.inquiryId)
        toggleViewDetails();
    }

    const switchHandler = (data) => {

    }

    const columns = useMemo(() => [
        {
            Header: 'Rate Source',
            accessor: 'isMarketPlace',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{cellProps.row.original?.isMarketPlace === true ? 'Network' : 'Own'}</span>
                );
            }
        },
        {
            Header: 'Inquiry Type',
            accessor: 'rateType',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{cellProps.row.original?.rateType.replace("_", " ")}</span>
                );
            }
        },
        {
            Header: 'Inquiry Dt',
            accessor: 'inquiryDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{formatModifyDate(cellProps.row.original?.inquiryDate)}</span>
                )
            }
        },
        {
            Header: 'Inquiry ID',
            accessor: 'inquiryId',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Origin',
            accessor: 'origin',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Destination',
            accessor: 'destination',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Cargo Ready Date',
            accessor: 'cargoDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                if(cellProps?.row?.original?.rateType === 'AIR') {
                    const cargoDate = cellProps.row.original?.cargoDate;
                    return <span>{cargoDate ? formatModifyDate(cargoDate) : '/'}</span>;
                } else {
                    const cargoDate = cellProps.row.original?.cargoDate;
                    const cargoDateSplit = typeof cargoDate === "string" ? cargoDate.split('/') : [];
                    return (cargoDateSplit[0] !== "" && cargoDateSplit[1] !== "") ? (
                        <span>{formatModifyDate(cargoDateSplit[0])}/{formatModifyDate(cargoDateSplit[1])}</span>
                    ) : <span>/</span>;
                }
            }
        },
        {
            Header: 'Cargo Details',
            accessor: 'viewDetails',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <label className="form-label" onClick={(e) => {
                        e.stopPropagation();
                        viewDetails(cellProps.row.original);
                    }}>
                        <span className="align-content-center">View Details</span>
                    </label>
                )
            }
        },
        {
            Header: 'Status',
            accessor: 'statusCode',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Bids Received',
            accessor: 'totalBidCount',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <label className="form-label" onClick={() => viewBids(cellProps.row.original)}>
                        <span className="align-content-center text-decoration-underline">{cellProps.row.original?.totalBidCount}</span>
                    </label>
                );
            }
        },
    ], [networkInquiries]);

    const myInquiriesStatsData = [
        {
            title: 'Total Inquiries',
            value: networkInquiries?.totalInquiry || 0,
            percentage: 0,
            rate: '',
            rateType: 'down'
        },
        {
            title: 'Total Bids Received',
            value: networkInquiries?.totalBidReceived || 0,
            percentage: 0,
            rate: '',
            rateType: 'down'
        },
        {
            title: 'Total Bids Accepted',
            value:  networkInquiries?.totalBidAccepted || 0,
            percentage: 0,
            rate: '',
            rateType: 'up'
        },
        {
            title: 'Active Inquiries',
            value: networkInquiries?.totalActiveRecords || 0,
            percentage: 0,
            rate: '',
            rateType: 'down'
        }
    ];

    return (
        <>
            <Page>
                <StatsSummary
                    breadcrumb={MyInquiriesBreadcrumb}
                    stats={myInquiriesStatsData}
                />

                <MyInquiriesTable
                    tableRef={tableRef}
                    columns={columns}
                    data={!!networkInquiries.content ? networkInquiries.content : []}
                    isGlobalFilter={true}
                    isAddInvoiceList={true}
                    loader={inquiry_data_loader}
                    customPageSize={25}
                    toggleRightCanvas={toggleRightCanvas}
                    downLoadExcelReport={downLoadExcelReport}
                    component={'inquiryNetwork'}
                    setCurrentPage={setCurrentPage}
                    totalPages={networkInquiries?.totalPages || 0}
                    totalEntries={networkInquiries?.totalElements || 0}
                />
                <ViewDetails isOpen={isViewDetailsOpen} inquirieType={inquiriesType} inquirieId={inquiriesId} toggle={toggleViewDetails} />
            </Page>
            <FilterSalesInquiryComp isRight={isRight} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} />
        </>
    );
}

export default MyInquiries;
